/**
 * Performance Marker tag enum for all the performance markers
 */ export var MarkerTag = /*#__PURE__*/ function(MarkerTag) {
    // Very first tag to be marked once the app bootstrap gets called.
    MarkerTag["AppBootstrap"] = "AppBootstrap";
    // Marked when the Teams SDK is initialized. This is applicable for  Meta OS app.
    MarkerTag["InitializedTeamsSDK"] = "InitializedTeamsSDK";
    // Marked in the lifecycle of any smart component.
    MarkerTag["ViewRender"] = "ViewRender";
    // Marked when the app load is started from cache.
    MarkerTag["CachedLoadStart"] = "CachedLoadStart";
    // Marked when the app load completes from cache.
    MarkerTag["CachedLoadComplete"] = "CachedLoadComplete";
    // Marked when the view data fetch cycle meets the checkpoints.
    MarkerTag["ViewDataFetch"] = "ViewDataFetch";
    // Marked when the child app instantiation starts.
    MarkerTag["ChildAppInstantiation"] = "ChildAppInstantiation";
    // Marked in the DataPreFetcher flow.
    MarkerTag["DataPreFetcher"] = "DataPreFetcher";
    // Marked when the boot completes according to BootObserverWorker.
    MarkerTag["BootCompleted"] = "BootCompleted";
    // Marked when the store hydration of a page starts.
    MarkerTag["StoreHydration"] = "StoreHydration";
    // Marked when MSAL initialization starts
    MarkerTag["InitializeMSALStart"] = "InitializeMSALStart";
    // Marked when MSAL initialization completes
    MarkerTag["InitializeMSALComplete"] = "InitializeMSALComplete";
    // Marked when MSAL login starts
    MarkerTag["MSALLoginStart"] = "MSALLoginStart";
    // Marked when MSAL login completes
    MarkerTag["MSALLoginComplete"] = "MSALLoginComplete";
    // Marked when culture data initialization completes
    MarkerTag["InitializeCultureDataComplete"] = "InitializeCultureDataComplete";
    // Marked when context is fetched and moment culture is set
    MarkerTag["GetContextAndSetMomentCultureComplete"] = "GetContextAndSetMomentCultureComplete";
    // Marked when context is fetched and moment culture is set
    MarkerTag["GetContextComplete"] = "GetContextComplete";
    // Marked when the initial route is determined
    MarkerTag["GetInitialRouteComplete"] = "GetInitialRouteComplete";
    // Marked when an access token acquisition starts
    MarkerTag["GetAccessTokenStart"] = "GetAccessTokenStart";
    // Marked when an access token is successfully acquired
    MarkerTag["GetAccessTokenComplete"] = "GetAccessTokenComplete";
    // Marked when MSAL force login completes
    MarkerTag["MSALForceLoginComplete"] = "MSALForceLoginComplete";
    // Marked when MSAL helper is initialized
    MarkerTag["MSALHelperInitialized"] = "MSALHelperInitialized";
    // Marked when MSAL auth redirect handling is complete
    MarkerTag["MSALAuthRedirectComplete"] = "MSALAuthRedirectComplete";
    // Marked when the Ocdi redirect news bar is shown
    MarkerTag["ShowOcdiRedirNewsBarComplete"] = "ShowOcdiRedirNewsBarComplete";
    // Marked when the bootstrap CAE probe starts
    MarkerTag["CaeProbeStart"] = "CaeProbeStart";
    // Marked when the bootstrap CAE probe completes
    MarkerTag["CaeProbeComplete"] = "CaeProbeComplete";
    // Marked when a tracked user interaction completes (used for RAP measurement)
    MarkerTag["UserInteraction"] = "UserInteraction";
    // Web Vitals CLS report: browser-measured layout stability with attribution.
    MarkerTag["CLS"] = "CLS";
    // Web Vitals LCP report: browser-measured loading performance with attribution.
    MarkerTag["LCP"] = "LCP";
    // Web Vitals INP report: browser-measured interaction latency with target
    // selector and input/processing/presentation delay breakdown.
    MarkerTag["INP"] = "INP";
    return MarkerTag;
}({});
